import React from "react";
import { useTranslation } from "react-i18next";
import Switch from "react-switch";
import "./LanguageSwitch.css";

function LanguageSwitch() {
  const { i18n, t } = useTranslation();

  const handleLanguageToggle = () => {
    const newLanguage = i18n.language === "en" ? "ru" : "en";
    i18n.changeLanguage(newLanguage);
    localStorage.setItem("userLanguageChoice", newLanguage);
  };

  return (
    <div className="language-switch">
      <label htmlFor="language-switch-toggle" className="sr-only">
        {t("language_switch_label") || "Switch language"}
      </label>
      <Switch
        id="language-switch-toggle"
        onChange={handleLanguageToggle}
        checked={i18n.language === "ru"}
        offColor="#cccccc"
        onColor="#111111"
        offHandleColor="#ffffff"
        onHandleColor="#ffffff"
        handleDiameter={22}
        uncheckedIcon={<div className="switch-label switch-label-unchecked">EN</div>}
        checkedIcon={<div className="switch-label switch-label-checked">RU</div>}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
        activeBoxShadow="0px 0px 1px 10px rgba(0, 123, 255, 0.2)"
        height={28}
        width={60}
        className="react-switch"
        aria-label={t("language_switch_label") || "Switch language"}
      />
    </div>
  );
}

export default LanguageSwitch;
